export function Marquee({ items, dark = false, className = "" }) {
  const Row = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((it, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-7 font-serif text-xl italic tracking-wide sm:text-2xl">{it}</span>
          <span className="text-sm text-gold">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 ${
        dark ? "border-ink bg-ink text-paper" : "border-blushdeep bg-blush text-ink"
      } ${className}`}
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
